export default "__VITE_ASSET__DOFKj0WR__"